import React from "react";
import SeoHead from "src/components/Seo/SeoHead";
import useTranslation from "next-translate/useTranslation";
import { Paragraph, Claim, Short, Headline, HeadlineTeaser } from "src/components/DefaultPage/DefaultPageTypography";
import Header from "src/components/DefaultPage/Header";
import Content from "src/components/DefaultPage/Content";
import Page from "src/components/DefaultPage/Page";
import { makeStyles } from "@material-ui/core/styles";
import { TheCycleverseTheme } from "src/theme";

const useStyles = makeStyles((theme: TheCycleverseTheme) => ({
  header: {
    color: `${theme.palette.primary.main}!important`,
  },
}));

const About = () => {
  const classes = useStyles();
  const { t } = useTranslation("about");

  return (
    <Page
      dataTestId="page-about"
      seoHead={<SeoHead title={t("common:footerAbout")} />}
      header={
        <Header
          title={<span>{t("aboutTitle")}</span>}
          intro={
            <>
              <span>{t("aboutIntro1")}</span>
              <span>{t("aboutIntro2")}</span>
              <span>{t("aboutIntro3")}</span>
            </>
          }
          backgroundImageDesktop="/images/Header-About.jpg"
          backgroundImageMobile="/images/Header-About-Mobile.jpg"
          className={classes.header}
        />
      }
      content={
        <Content
          headline={
            <>
              <HeadlineTeaser>{t("aboutTeaser")}</HeadlineTeaser>
              <Headline>{t("aboutHeadline")}</Headline>
            </>
          }
          short={<Short>{t("aboutShort")}</Short>}
        >
          <Paragraph>{t("aboutParagraph1")}</Paragraph>
          <Paragraph>{t("aboutParagraph2")}</Paragraph>
          <Claim>{t("aboutClaim")}</Claim>
          <Paragraph>{t("aboutParagraph3")}</Paragraph>
          <Paragraph>{t("aboutParagraph4")}</Paragraph>
        </Content>
      }
    />
  );
};

export default About;
